<template>
    <div class="layout">
      <div class="memento">
        <v-card elevation="0" class="cardMemento">
          <!-- Start Details Intervention Memento -->
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-card-title>
                {{ $t("mementoDetails.title") }} {{ $route.params.id }}
              </v-card-title>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-card-title v-if="lastBeforeExist" class="before-state right">
               {{ $t("mementoDetails.titlePreviousRecord") }} {{ lastBeforeEvent.id }}
              </v-card-title>             
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trDateCreatedState") }}</span> 
                <br/>
                {{ mementoSelected.dateCreatedState | dateFormat }}
              </v-card-text>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.recordInfo") }}</span> 
                <br/>
                Event {{ mementoSelected.mementoMessage.messageInterventionId }} 
                {{ mementoSelected.mementoMessage.messageAction }} 
                {{ mementoSelected.mementoMessage.userEmail }}.
                <br/>
                <span v-if="mementoSelected.mementoMessage.modificationsDone != ``">
                  <span class="font-weight-medium">{{ $t("mementoDetails.modifications") }}</span> 
                  {{ mementoSelected.mementoMessage.modificationsDone }} 
                </span>
              </v-card-text>
            </v-col>
          </v-row>
          <!-- End Details Intervention Memento -->

          <!-- Start Details Intervention -->
          <v-card-title class="pt-7">{{ $t("mementoDetails.eventInfo") }}</v-card-title>
          <v-row>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trInterventionId") }}</span> 
                {{ mementoSelected.state.interventionId }}
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trComment") }}</span>
                <span v-if="mementoSelected.state.comment != null">{{ mementoSelected.state.comment }}</span>
                <span>{{ $t("mementoDetails.none") }}</span> 
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.comment != lastBeforeEvent.state.comment" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  <span v-if="mementoSelected.state.comment != null">{{ lastBeforeEvent.state.comment }}</span> 
                  <span>{{ $t("mementoDetails.none") }}</span> 
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trType") }}</span> 
                <span v-for="uType in $enumInterventionStatus" :key="uType.value">
                  <span v-if="mementoSelected.state.type === uType.value">{{ uType.text }}</span>
                </span>
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.type != lastBeforeEvent.state.type" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  <span v-for="uType in $enumInterventionStatus" :key="uType.value">
                    <span v-if="lastBeforeEvent.state.type === uType.value">{{ uType.text }}</span>
                  </span>
                </div>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trUserFullName") }}</span> 
                {{ mementoSelected.state.userFullName }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.userFullName != lastBeforeEvent.state.userFullName" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.userFullName }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trCourseTitle") }}</span> 
                {{ mementoSelected.state.courseTitle }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.courseTitle != lastBeforeEvent.state.courseTitle" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.courseTitle }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trLocationCity") }}</span> 
                {{ mementoSelected.state.locationCity }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.locationCity != lastBeforeEvent.state.locationCity" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.locationCity }}
                </div>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <v-card-text>
                <v-row align="center" class="mx-0">
                  <span class="font-weight-medium">{{ $t("mementoDetails.trValidated") }}</span> 
                  <v-simple-checkbox v-model="mementoSelected.state.validated" disabled></v-simple-checkbox>
                </v-row>
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.validated != lastBeforeEvent.state.validated" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span>
                  {{ lastBeforeEvent.state.validated === true ? $t("mementoDetails.validatedTrue") : $t("mementoDetails.validatedFalse") }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trDateStart") }}</span> 
                {{ mementoSelected.state.dateStart }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.dateStart != lastBeforeEvent.state.dateStart" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.dateStart }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trDateEnd") }}</span> 
                {{ mementoSelected.state.dateEnd }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.dateEnd != lastBeforeEvent.state.dateEnd" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.dateEnd }}
                </div>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <v-card-text>
                <v-row align="center" class="mx-0">
                  <span class="font-weight-medium">{{ $t("mementoDetails.trMaster") }}</span> 
                  <v-simple-checkbox v-model="mementoSelected.state.master" disabled></v-simple-checkbox>
                </v-row>
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.master != lastBeforeEvent.state.master" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span>
                  {{ lastBeforeEvent.state.master === true ? $t("mementoDetails.true") : $t("mementoDetails.false") }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trTimeStart") }}</span> 
                {{ mementoSelected.state.timeStart }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.timeStart != lastBeforeEvent.state.timeStart" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.timeStart }}
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card-text>
                <span class="font-weight-medium">{{ $t("mementoDetails.trTimeEnd") }}</span> 
                {{ mementoSelected.state.timeEnd }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.timeEnd != lastBeforeEvent.state.timeEnd" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.timeEnd }}
                </div>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4">
              <v-card-text v-if="mementoSelected.state.masterInterventionId != 0">
                <span class="font-weight-medium">{{ $t("mementoDetails.trMasterInterventionId") }}</span> 
                {{ mementoSelected.state.masterInterventionId }}
                <br/>
                <div v-if="lastBeforeExist && mementoSelected.state.masterInterventionId != lastBeforeEvent.state.masterInterventionId" class="before-state">
                  <span>{{ $t("mementoDetails.previousState") }}</span> 
                  {{ lastBeforeEvent.state.masterInterventionId }}
                </div>
              </v-card-text>
            </v-col>
            <v-col>
            </v-col>
            <v-col>
            </v-col>
          </v-row>
          <!-- End Details Intervention -->
          <v-card-actions>
            <v-btn @click="goBack">
              <v-icon dark>
                mdi-arrow-left
              </v-icon>
              {{ $t("mementoDetails.back") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
</template>

<script>
import {
  getIMementoByIdHttp,
  getIMementoLastBeforeHttp
} from "@/services/planning/MementoService.js";

export default {
  props: [],
  components: {
  },
  data() {
    return {
      mementoSelected: {
        id: '',
        version: '',
        state: {},
        dateCreatedState: '',
        mementoMessage: {
          messageAction: '',
          messageInterventionId: '',
          modificationsDone: '',
          userEmail: ''
        },
      },
      lastBeforeEvent: { 
        id: '',
        version: '',
        state: {},
        dateCreatedState: '',
        mementoMessage: {
          messageAction: '',
          messageInterventionId: '',
          modificationsDone: '',
          userEmail: ''
        },
      },
      lastBeforeExist: true,
    };
  },
  async mounted() {
    await this.getById();
    await this.getLastBeforeMemento();
  },
  created() {
  },
  filters: {
    dateFormat: function (value) {
      if (value) {
        value = new Date(value);
        return value.getFullYear() + '-' + ((value.getMonth() < 9) ? '0' : '') + (value.getMonth() + 1) + '-' +
        ((value.getDate() < 10) ? '0' : '') + value.getDate() + ' à ' + value.toLocaleTimeString();
      }
    }
  },
  methods: {
  /**
   * This method will give information about the memento selected by the client
   */
    async getById() {
      await getIMementoByIdHttp(this.$route.params.id).then((response) => {
        this.mementoSelected = response.data;
      })
    },
  /**
   * This method will give information about previous modifications done just before the selected memento
   */
    async getLastBeforeMemento() {
      await getIMementoLastBeforeHttp(this.mementoSelected.state.interventionId, this.mementoSelected.id)
      .then((response) => {
        this.lastBeforeEvent = response.data;
      })
      .catch((error) => {
        this.lastBeforeExist = false;
      })
    },
  /**
   * This method allows to go back to the previous page
   */
    goBack() {
      return this.$router.go(-1);
    }
  },
};
</script>

<style lang="scss">
.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.memento {
  margin: 3rem auto;
  width: 80%;
}

.cardMemento {
  padding: 3rem 3rem;
}

.before-state {
  color: #b6b6b6;
  font-style: italic;
}

.right {
  font-size: 0.9rem;
}
</style>